import { useAuth0 } from "@auth0/auth0-react";
import AuthService from 'Lib/API/Auth';
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import { useFormik } from "formik";
import React, { Fragment, useEffect, useState } from 'react';
import { Col } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { Statement } from './Statement';
import { TaxReport } from './TaxReport';
import InfoTooltip from "components/InfoTooltip";
import { Button, ButtonGroup, Content, CreateButton, Label, StatementButton, TaxButton, Wrapper } from './Theme';
const accountTypeOptions = [
    {
        label: "Member",
        value: "member",
    },
    {
        label: "Organization",
        value: "organization",
    },
    {
        label: "Not a Member",
        value: "non-member",
    },
]

export const NewBatchDocument = ({ setOpenBatchDocument, closeCheck, setCloseCheck }) => {
    const [typeClicked, setTypeClicked] = useState('tax_statement')
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [isLoading, setIsLoading] = useState(false)
    const { getAccessTokenSilently } = useAuth0();
    const [catagoryTypes, setCatagoryTypes] = useState([]);
    const [accountBillingTypes, setAccountBillingTypes] = useState(null);
    const [ledgers, setLedgers] = useState([]);
    const [isLedgerLoading, setIsLedgerLoading] = useState(false);

    const [accountTags, setAccountTags] = useState([]);
    const [accountTagsLoading, setAccountTagsLoading] = useState(false);
    const [contactTags, setContactTags] = useState([]);
    const [contactTagsLoading, setContactTagsLoading] = useState(false);
    const formik = useFormik({
        isInitialValid: false,
        enableReinitialize: true,
        initialValues: {
            all_ledger_sub_data: [],
            selectAllLedger: false,
            selectAllSubLedger: false,
            tax_report: {
                filter: { accountTags: [], contactTags: [] },
                type: 'tax_report',
                deleteOldDocument: false,
                deleteNoTransaction: false,
                start: `${new Date()?.getFullYear()}-01-01`, end: `${new Date()?.getFullYear()}-12-31`,
                taxOverride: false,
                addNote: false,
                note: "",
            },
            tax_statement: {
                filter: { accountTags: [], contactTags: [] },
                type: 'tax_statement',
                deleteOldDocument: false,
                showZero: false,
                deleteNoTransaction: false,
                showBalance: false,
                allOpenCharges: false,
                addNote: false,
                note: "",
                excludeActivePayment: false,
            }
        },
        validationSchema: "",
        onSubmit: async (values) => { },
    });

    const handleTypeButton = (Type) => {
        formik.setFieldValue(`${Type}`, {
            filter: {
                accountTags: [],
                contactTags: [],
            },
            type: `${Type}`,
            deleteOldDocument: false,
            showZero: false,
            start: `${new Date()?.getFullYear()}-01-01`,
            end: `${new Date()?.getFullYear()}-12-31`,
        });
        setCatagoryTypes([])
        setAccountBillingTypes(null)
        setDateRange([null, null])
        setTypeClicked(Type)
        formik.setFieldValue("all_ledger_sub_data", []);
        formik.setFieldValue("ledger", []);
        formik.setFieldValue("subLedger", []);
    }
    const accountCategoryOptions =
        catagoryTypes?.map((item) => {
            return {
                label: item?.title,
                value: item?._id,
            };
        });
    const billingTypeOptions =
        accountBillingTypes?.map((item) => {
            return {
                label: item?.title,
                value: item?._id,
            };
        });

    const getTypes = async () => {
        const token = await getAccessTokenSilently();
        const type = formik.values[typeClicked]?.filter?.account_type
        if (type) {
            console.log("type", type);
            await MembersSettingService.getCatagoryListByType(type, token
            ).then((res) => {
                setCatagoryTypes(res?.result);
            });
        }
    };
    const fetchAccountBillingTypes = async () => {
        const token = await getAccessTokenSilently();
        await FinanceSettingService.getAccountBillingTypes(token).then((res) => {
            setAccountBillingTypes(res?.result);
        });
    };

    useEffect(() => {
        getTypes();
        fetchAccountBillingTypes();
        getAccountTagsHandler();
        getContactTagsHandler();
    }, [formik.values[typeClicked]?.filter?.account_type]);

    useEffect(() => {
        setIsLedgerLoading(true);
        async function getLedgeraccounts() {
            const token = await getAccessTokenSilently();
            const res = await FinanceService.getLedgerSubLedgerListAll(token);
            if (res?.ledgers) {
                const arrayWithSelectAll = ["Select All", ...res?.ledgers];
                setLedgers(arrayWithSelectAll);
            }
            setIsLedgerLoading(false);
        }
        getLedgeraccounts();
    }, [getAccessTokenSilently]);

    const getAllSelectedLedger = () => {
        const { all_ledger_sub_data } = formik?.values || {};

        if (!all_ledger_sub_data || !all_ledger_sub_data?.length) return { allLedgerIds: [], allSubLedgerIds: [] };

        const allLedgerIds = [];
        const allSubLedgerIds = [];

        all_ledger_sub_data.forEach(({ type, id }) => {
            if (type === "ledger") {
                allLedgerIds.push(id);
            } else if (type === "sub_ledger") {
                allSubLedgerIds.push(id);
            }
        });

        return {
            allLedgerIds,
            allSubLedgerIds,
        };
    }


    const handleCreateButton = async () => {
        const { allLedgerIds } = getAllSelectedLedger();
        if (typeClicked === 'tax_report' && (!formik.values?.tax_report?.batchName || !formik.values?.tax_report?.end || !formik.values?.tax_report?.start) || (formik.values?.tax_report?.addNote && !formik.values?.tax_report?.note)) {
            toastr.error("Error", "Please fill in the required fields");
        } else if (typeClicked === 'tax_statement' && (!formik.values?.tax_statement?.batchName || (!formik.values.tax_statement.allOpenCharges && (!startDate || !endDate)) || (formik.values?.tax_statement?.addNote && !formik.values?.tax_statement?.note))) {
            toastr.error("Error", "Please fill in the required fields");
        } else {
            const token = await getAccessTokenSilently()
            let body
            if (typeClicked === 'tax_statement') {
                body = {
                    ...formik.values.tax_statement,
                    addNote: undefined,
                    start: !formik.values.tax_statement.allOpenCharges ? startDate?.toLocaleDateString("en-CA") : undefined,
                    end: !formik.values.tax_statement.allOpenCharges ? endDate?.toLocaleDateString("en-CA") : undefined,
                    ledger: formik?.values?.selectAllLedger ? allLedgerIds : formik.values?.ledger || [],
                    subLedger: (formik?.values?.selectAllLedger && formik?.values?.selectAllSubLedger) ? [] : formik.values?.subLedger || [],
                    allOpenCharges: formik.values.tax_statement.allOpenCharges,
                    showZero: !formik.values.tax_statement.allOpenCharges ? formik.values.tax_statement.showZero : undefined,
                    filter: {
                        ...formik.values.tax_statement.filter,
                        accountTags: formik.values.tax_statement.filter.accountTags?.length ? formik.values.tax_statement.filter.accountTags?.map((item) => item.label) : undefined,
                        contactTags: formik.values.tax_statement.filter.contactTags?.length ? formik.values.tax_statement.filter.contactTags?.map((item) => item.label) : undefined
                    },
                }
            } else if (typeClicked === 'tax_report') {
                body = {
                    ...formik.values.tax_report,
                    addNote: undefined,
                    ledger: formik?.values?.selectAllLedger ? allLedgerIds : formik.values?.ledger || [],
                    subLedger: (formik?.values?.selectAllLedger && formik?.values?.selectAllSubLedger) ? [] : formik.values?.subLedger || [],
                    filter: {
                        ...formik.values.tax_report.filter,
                        accountTags: formik.values.tax_report.filter.accountTags?.length ? formik.values.tax_report.filter.accountTags?.map((item) => item.label) : undefined,
                        contactTags: formik.values.tax_report.filter.contactTags?.length ? formik.values.tax_report.filter.contactTags?.map((item) => item.label) : undefined
                    },
                }
            } else {
                body = formik.values[typeClicked];
                body.ledger = formik?.values?.selectAllLedger ? allLedgerIds : formik.values?.ledger || [];
                body.subLedger = (formik?.values?.selectAllLedger && formik?.values?.selectAllSubLedger) ? [] : formik.values?.subLedger || [];
            }
            if (token) {
                setIsLoading(true)
                try {
                    const res = await FinanceService.setBatchDocuments(token, body)
                    setIsLoading(false);
                    toastr.success("Success", "Successfully Completed");
                    setOpenBatchDocument(false)
                    setCloseCheck(!closeCheck)
                } catch (error) {
                    toastr.error("Error", error?.data?.message || error);
                    setIsLoading(false);
                } finally {
                    setIsLoading(false);
                }
            } else {
                toastr.error('Something went wrong contact with support team please', {
                    variant: 'error',
                });
                setIsLoading(false);
            }
        }
    }

    const getAccountTagsHandler = async () => {
        const token = await getAccessTokenSilently();
        setAccountTagsLoading(true);
        AuthService.getTags(
            'account',
            "",
            "",
            token
        )
            .then((res) => {
                const tags = res?.result;
                const filterTags = tags?.map((item) => {
                    return {
                        label: item?.title,
                        value: item?._id,
                    };
                });
                setAccountTags(filterTags);
            })
            .catch((err) => {
                console.log('err: ', err);
                toastr.error('Error', err?.data?.message || 'Something went wrong');
            }).finally(() => {
                setAccountTagsLoading(false);
            });
    };
    const getContactTagsHandler = async () => {
        const token = await getAccessTokenSilently();
        setContactTagsLoading(true);
        AuthService.getTags(
            'contact',
            "",
            "",
            token
        )
            .then((res) => {
                const tags = res?.result;
                const filterTags = tags?.map((item) => {
                    return {
                        label: item?.title,
                        value: item?._id,
                    };
                });
                setContactTags(filterTags);
            })
            .catch((err) => {
                console.log('err: ', err);
                toastr.error('Error', err?.data?.message || 'Something went wrong');
            }).finally(() => {
                setContactTagsLoading(false);
            });
    };

    return (
        <form onSubmit={formik.handleSubmit} className="d-flex flex-column align-items-center">
            <Fragment>
                <Label>Document type</Label>
                <div className="d-flex align-items-center" style={{ marginTop: '10px', marginBottom: '41px' }}>
                <Wrapper style={{ marginTop: 0, marginBottom: 0 }}>

                    <div
                        className="d-flex align-items-center"
                        style={{ height: "36px" }}
                    >
                        <StatementButton
                            type="button"
                            onClick={() => handleTypeButton('tax_statement')}
                            isClicked={typeClicked}
                            className={
                                typeClicked === "tax_statement"
                                    ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                                    : `btn  btn-clean font-weight-bold m-2 d-flex align-items-center`
                            }
                        >
                            Statement
                        </StatementButton>
                        <TaxButton
                            type="button"
                            onClick={() => handleTypeButton('tax_report')}
                            className={
                                typeClicked === "tax_report"
                                    ? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
                                    : `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
                            }
                            style={{ height: "24px" }}
                        >
                            Tax Report
                        </TaxButton>

                    </div>

                </Wrapper>
                <InfoTooltip text="Statement generates a summary of charges/payments per account. Tax Report generates tax-deductible giving totals for the year, used for donor tax receipts." placement="bottom" style={{ marginLeft: '8px' }} />
                </div>
                <Content>
                    {typeClicked === 'tax_report' ?
                        <TaxReport formik={formik}
                            accountCategoryOptions={accountCategoryOptions} billingTypeOptions={billingTypeOptions}
                            ledgers={ledgers}
                            isLedgerLoading={isLedgerLoading}
                            accountTags={accountTags} accountTagsLoading={accountTagsLoading}
                            contactTags={contactTags} contactTagsLoading={contactTagsLoading}
                            accountTypeOptions={accountTypeOptions}
                        /> :
                        <Statement formik={formik}
                            startDate={startDate} DateRange={setDateRange} endDate={endDate}
                            accountCategoryOptions={accountCategoryOptions} billingTypeOptions={billingTypeOptions}
                            ledgers={ledgers}
                            isLedgerLoading={isLedgerLoading}
                            accountTags={accountTags} accountTagsLoading={accountTagsLoading}
                            contactTags={contactTags} contactTagsLoading={contactTagsLoading}
                            accountTypeOptions={accountTypeOptions}
                        />
                    }
                </Content>
                <Col className="col-12 col-md-12">
                    <Button>
                        <CreateButton onClick={handleCreateButton} disabled={isLoading} isLoading={isLoading}><p>
                            Create
                        </p></CreateButton>
                    </Button>
                </Col>
            </Fragment>
        </form>
    );
};
